import { jsx as u } from "react/jsx-runtime";
const H = ({
  children: r,
  className: n,
  index: f,
  semanticType: o = "h2",
  visualType: t = o !== "h6" ? o : "h5",
  id: e
}) => r ? typeof f == "number" && f === 0 ? /* @__PURE__ */ u("h1", { id: e, className: `${n} ${t}`, children: r }) : /* @__PURE__ */ u(o, { id: e, className: [n, t || ""].join(" "), children: r }) : null;
export {
  H as Heading,
  H as default
};
